var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"x":"0.5","y":"1","width":"15","height":"15","rx":"2.5","fill":"white"}}),_c('rect',{attrs:{"x":"0.5","y":"1","width":"15","height":"15","rx":"2.5","stroke":"#C8D0DD"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }